import { Table } from 'antd';
import React from 'react';
import styled from 'styled-components';
import constants from './dashboard/constants';

const assessmentMethods = constants.AssessmentMethods;

export const assessmentMethodMap = {
	Phone: 'Phone Screening',
	Default: 'Talents Arena Assessment'
	// 'Custom':'Custom Assessment'
};

const AssessmentTable = styled(Table)`
	.ant-radio-inner {
		border-color: rgba(0, 0, 0, 0.1);
	}
	.ant-radio-checked .ant-radio-inner,
	.ant-radio-checked::after {
		border-color: ${({ theme }) => theme.TA_GREEN};
	}
	.ant-radio-inner::after {
		background-color: ${({ theme }) => theme.TA_GREEN};
	}
`;

interface IAssessmentSurveyForm {
	value: any;
	onChange: (val: any) => void;
}
class AssessmentSurveyForm extends React.Component<IAssessmentSurveyForm> {
	state = {
		value: this.props.value
	};
	componentWillReceiveProps(nextProps) {
		// Should be a controlled component.
		if (this.props.value !== nextProps.value) {
			this.setState({ value: nextProps.value });
		}
	}

	tableColumns = [
		{
			title: 'Filtering Method',
			key: 'filtering',
			dataIndex: 'filteringMethod',
			width: '30%',
			render: text => <span>{text}</span>
		},
		{
			title: '',
			key: 'tag',
			dataIndex: 'tag',
			width: '5%',
			render: text => <span>{text}</span>
		},
		{
			title: 'Time',
			key: 'time',
			dataIndex: 'time',
			render: text => (
				<span>
					{text.min}-{text.max} days
				</span>
			)
		},
		{
			title: 'Price',
			key: 'price',
			dataIndex: 'price',
			render: text => <span>{`${text === 0 ? 'Free' : '$ ' + text}`}</span>
		}
	];

	onAssessmentChange = row => {
		this.setState({ value: row[0] });
		this.props.onChange(row[0]);
	};

	render() {
		return (
			<AssessmentTable
				rowSelection={{
					type: 'radio',
					selectedRowKeys: [this.state.value],
					onChange: this.onAssessmentChange
				}}
				style={{ overflow: 'hidden' }}
				dataSource={assessmentMethods}
				columns={this.tableColumns}
				pagination={false}
			/>
		);
	}
}

export default AssessmentSurveyForm;
